import axios from "axios";
import { addToGlobalThisRet } from "@plugins";

const formValidator = async (form, fontApiUrl) => {
    const fileAttacher = form.querySelector(".js-simple-form-files");
    const personalCheckBox = form.querySelector(".js-check-send-form");
    const customSelect = form.querySelector(".js-input-select-target");

    const errorElements = (await initValidation(form, fontApiUrl)).filter((item) => item.hasError);

    return (
        !errorElements.length && checkPersonal(personalCheckBox) && checkAttachedFiles(fileAttacher)
    );
};

const initValidation = async (target, fontApiUrl) => {
    const elemsArray = Array.from(target.elements).slice();

    for (const element of elemsArray) {
        if (element.dataset.validate || element.hasAttribute("data-required")) {
            const type = element.dataset.validate;

            switch (type) {
                case "phone":
                    if (element.value.replace(/[^0-9]/gi, "").length < 11) {
                        initError(element, "телефона");
                    } else {
                        try {
                            const response = await axios.get(`${fontApiUrl}${element.value}`);

                            if (response.data.status === "ok") {
                                clear(element, "full");
                            } else {
                                initError(element, "телефона");
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    }
                    break;
                case "email":
                    if (checkEmail(element.value)) {
                        clear(element, "full");
                    } else {
                        initError(element, "e-mail");
                    }
                    break;
                default:
                    if (!element.value.length) {
                        initError(element);
                    } else {
                        clear(element);
                    }
                    break;
            }
        }
    }

    return elemsArray;
};

const checkEmail = (email) => {
    const pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i,
    );
    return pattern.test(email);
};

const checkPersonal = (personal) => {
    if (!personal) return true;

    const input = personal.querySelector("input");
    const icon = personal.querySelector(".checkbox__icon");

    if (input.checked) {
        icon.classList.remove("form-error");

        return true;
    } else {
        icon.classList.add("form-error");

        return false;
    }
};

const checkAttachedFiles = (fileAttacher) => {
    if (!fileAttacher) return true;

    const filesList = fileAttacher.querySelector(".simple-form__files-list");
    const isFilesListEmpty = filesList?.children.length ? false : true;

    if (!filesList || (filesList && isFilesListEmpty)) {
        if (!fileAttacher.querySelector(".form-error-text")) {
            fileAttacher
                .querySelector(".js-simple-form-files-label")
                .insertAdjacentHTML(
                    "afterend",
                    `<div class="form-error-text">* Вы не прикрепили документы</div>`,
                );

            return false;
        }
    } else {
        return true;
    }
};

const initError = (element, type) => {
    element.hasError = true;

    if (!element.classList.contains("form-error")) {
        element.classList.add("form-error");

        if (type) {
            element.insertAdjacentHTML(
                "afterend",
                `<div class="form-error-text">* Ошибка. Проверьте корректность введенного ${type}</div>`,
            );
        }
    }

    if (element.classList.contains("js-input-select-target")) {
        const parent = document.querySelector(".js-input-select-init");
        if (parent) parent.classList.add("error");
    }
};

const clear = (element, remove) => {
    element.hasError = false;

    if (element.classList.contains("form-error")) {
        element.classList.remove("form-error");

        if (remove) {
            element.nextSibling.remove();
        }
    }

    if (element.classList.contains("js-input-select-target")) {
        const parent = document.querySelector(".js-input-select-init");
        if (parent) parent.classList.remove("error");
    }
};

addToGlobalThisRet(formValidator, "frontFormValidator");
